import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const solutions = [{
    title: 'Tomar más café',
    description: 'solo eleva tu cortisol, desatando más ansiedad y garantizando un "estallido" de niebla mental al mediodía.'
  }, {
    title: 'Dormir más horas',
    description: 'no sirve de nada si tu cerebro no puede activar el sistema de limpieza "glinfático" debido al calor y la inflamación.'
  }, {
    title: 'Los suplementos genéricos',
    description: 'no funcionan porque no atacan la raíz: el cambio en la forma en que tus neuronas queman energía tras la caída de estrógenos.'
  }, {
    title: 'Intentar "echarle ganas"',
    description: 'es como acelerar un coche que no tiene aceite; solo desgastas más el motor.'
  }];
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-29">
      <div className="max-w-4xl mx-auto px-6" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-teal-900" data-id="element-32">
            Por Qué Lo Que Intentaste No Funcionó
          </h2>

          <div className="space-y-6" data-id="element-33">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-4 items-start bg-gray-50 p-6 rounded-lg" data-id="element-34">
                <XCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-35" />
                <div data-id="element-36">
                  <span className="font-semibold text-lg text-gray-900" data-id="element-37">
                    {solution.title}
                  </span>
                  <span className="text-gray-700" data-id="element-38"> {solution.description}</span>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}